export const ONE_VS_ONE = '1v1';
export const ONE_VS_CPU = '1vscpu';
export const SAVE = 'save';
export const IMPORT = 'import';
export const EXPORT = 'export';
export const ONLINE = 'online';
export const FLIP = 'flip';
